import Vue from 'vue'
import axios from 'axios'
import {getLID, isCnkiEnv, jumptoLogin} from "@/utils/tools";
import {Message, Loading} from "element-ui";

const request = axios.create({
  // timeout: 40000 // 请求超时时间
});
// request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 添加请求拦截器
request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.baseURL = process.env.VUE_APP_API_URL;
  //
  if (process.env.VUE_APP_MODE === 'experiment' && !config.url.includes('teachplanC')) {
    config.url = config.url.replace('teachplan', 'teachplanC');
  }
  if (!isCnkiEnv() && !config.url.includes('OdataSearchV2')) {
    config.headers.Lid = getLID();
  }
  if (config.url.includes('OdataSearchV2')) {
    config.headers.Authorization = 'Bearer JhbGciOiJIUzI1NiJ9.eyJzdWIiOiJlZHViYXNldGVhY2htYXJrIiwiZXhwIjoxNzQxMDY3MjQ3fQ.JwSGDK54TbseiBvXScBWaHLs2gpGxBvhPHdYsSiDoao';
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
request.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response.data;
}, function (error) {
  console.log(error);
  if (error && error.response && error.response.data && error.response.data.status === 401) {
    jumptoLogin();
  }
  // 对响应错误做点什么
  return Promise.reject(error);
});

Vue.prototype.axios = request;

Vue.prototype.requestGet = function (url, params = null, cb, isLoading = false, finallyCb) {
  let loading = null;
  if (isLoading) loading = Loading.service({});
  return request.get(url, {params}).then((res) => {
    if (res && res.code === 200) {
      cb && cb(res.data, res);
    } else {
      console.log(url + '请求出错！');
      Message.error('请求出错！');
    }
  }).catch((err) => {
    Vue.prototype.showErrorMsg(err);
  }).finally(() => {
    if (loading) loading.close();
    finallyCb && finallyCb();
  });
}

Vue.prototype.requestPost = function (url, params = {}, cb, isLoading = false, finallyCb) {
  let loading = null;
  if (isLoading) loading = Loading.service({});
  return request.post(url, {...params}).then((res) => {
    if (res && res.code === 200) {
      cb && cb(res.data, res);
    } else {
      console.log(url + '请求出错！');
      Message.error('请求出错！');
    }
  }).catch((err) => {
    Vue.prototype.showErrorMsg(err);
  }).finally(() => {
    if (loading) loading.close();
    finallyCb && finallyCb();
  });
}


Vue.prototype.showErrorMsg = function (err) {
  console.log(err);
  if (err && err.response && err.response.status === 401) return;
  if (err && err.response) return Message.error('请求出错！');
  Message.error('内部错误！');
}
export default request
